import { Modal } from 'semantic-ui-react'
import React from 'react'

import { Collection } from '../../types'
import NoteForm from '../feeds/feedEditor/NoteForm'

interface Props {
  relatedCollection: Collection
  relatedId: string
  onSuccess(): Promise<any>
  onCancel?(): void
  show?: boolean
}

export default function AddLogModal({
  relatedCollection,
  relatedId,
  onCancel,
  onSuccess,
  show = true,
}: Props) {
  return (
    <Modal onClose={onCancel} open={show}>
      <Modal.Header>What you wanna log?</Modal.Header>
      <Modal.Content className="!pt-0">
        <NoteForm
          relatedCollection={relatedCollection}
          relatedId={relatedId}
          onSuccess={onSuccess}
          onCancel={onCancel}
          formId="note-form-modal"
        />
      </Modal.Content>
    </Modal>
  )
}
